import React from 'react'
import ReactDOM from 'react-dom'
import styled from 'styled-components'

/**
 * Portal component to be appended to the body element
 * destructured @param children DOM subnodes
 * @returns React FC
 */
const Portal: React.FC<any> = ({ children, ...props }) => {
  return ReactDOM.createPortal(
    children,
    document.body
  )
}

export default Portal
